/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetState } from './rolloutTargetState';


export interface RolloutTargetPatchRequest { 
    state: RolloutTargetState;
    /**
     * New Wave ID to reschedule the target.
     */
    new_wave_id?: string;
}
export namespace RolloutTargetPatchRequest {
}


